





import {apiV1AdminLifePath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostEdit from '@/components/admin/PostEdit'
import Post, {IPost} from '@/models/Post'
import Life from '@/models/Life'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm
  }
})
export default class LifeEdit extends PostEdit {
  async mounted(): Promise<void> {
    this.targetPath = apiV1AdminLifePath(this.$route.params.id)
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new Life(data)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '沖縄生活情報一覧',
        to: '/admin/lives',
        exact: true
      },
      {
        text: '沖縄生活情報編集'
      }
    ]
  }
}
